﻿// @ts-nocheck
// session edit/delete modal

// ========== Session Management (Edit/Delete) ==========
function openEditModal(session) {
  const modal = document.createElement("div");
  modal.id = "editSessionModal";
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  `;

  const startDate = new Date(session.startTime);
  const dateStr = startDate.toISOString().split("T")[0];
  const timeStr = String(startDate.getHours()).padStart(2, "0") + ":" + String(startDate.getMinutes()).padStart(2, "0");

  modal.innerHTML = `
    <div style="background: var(--bg-primary); padding: 2rem; border-radius: 0.75rem; max-width: 500px; width: 90%;">
      <h2>Edit Session</h2>
      
      <div class="form-group">
        <label>Project</label>
        <select id="editSessionProject">
          <option value="">– Select –</option>
          ${projects.map(p => `<option value="${p.id}" ${p.id === session.projectId ? 'selected' : ''}>${p.name}</option>`).join('')}
        </select>
      </div>

      <div class="inputs-row" style="margin-bottom: 0.75rem;">
        <div>
          <label>Date</label>
          <input type="date" id="editSessionDate" value="${dateStr}" />
        </div>
        <div>
          <label>Time</label>
          <input type="time" id="editSessionTime" value="${timeStr}" />
        </div>
      </div>

      <div class="form-group">
        <label>Hours</label>
        <input type="number" id="editSessionHours" value="${session.hours}" step="0.25" min="0.25" />
      </div>

      <div class="form-group">
        <label>Notes</label>
        <textarea id="editSessionNotes" rows="2">${session.notes || ''}</textarea>
      </div>

      <div style="display: flex; gap: 0.75rem; justify-content: flex-end;">
        <button class="btn btn-secondary" onclick="document.getElementById('editSessionModal').remove()">Cancel</button>
        <button class="btn btn-primary" onclick="saveSessionEdit('${session.id}')">Save Changes</button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);
}

async function saveSessionEdit(sessionId) {
  const projectId = document.getElementById("editSessionProject").value;
  const date = document.getElementById("editSessionDate").value;
  const time = document.getElementById("editSessionTime").value || "00:00";
  const hours = parseFloat(document.getElementById("editSessionHours").value);
  const notes = document.getElementById("editSessionNotes").value;

  if (!projectId || !date || !hours) {
    alert("Please fill in all required fields");
    return;
  }

  const project = projects.find(p => p.id === projectId);
  if (!project) {
    alert("Project not found");
    return;
  }

  try {
    const [year, month, day] = date.split("-").map(Number);
    const [timeHour, timeMin] = time.split(":").map(Number);
    // Create date in local timezone - Date object already handles this correctly
    const dateObj = new Date(year, month - 1, day, timeHour, timeMin, 0, 0);
    const startTime = dateObj.getTime();
    const endTime = startTime + hours * 60 * 60 * 1000;

    const res = await fetchWithAuth("/api/sessions/update", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: sessionId,
        projectId,
        projectName: project.name,
        startTime,
        endTime,
        hours,
        rate: project.defaultRate,
        earned: hours * project.defaultRate,
        notes,
      }),
    });

    if (!res.ok) {
      alert("Error updating session");
      return;
    }

    alert("Session updated!");
    document.getElementById("editSessionModal").remove();
    await loadSessions();
  } catch (err) {
    console.error("Error saving session:", err);
    alert("Error saving session");
  }
}

async function deleteSession(sessionId) {
  if (!confirm("Are you sure you want to delete this session?")) {
    return;
  }

  try {
    const res = await fetchWithAuth("/api/sessions/delete", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: sessionId }),
    });

    if (!res.ok) {
      alert("Error deleting session");
      return;
    }

    alert("Session deleted!");
    await loadSessions();
  } catch (err) {
    console.error("Error deleting session:", err);
    alert("Error deleting session");
  }
}
